import { ReactNode } from "react";
import { Text, View, Button } from "./base";
import { Icon } from "./base/Icon";
import { Dialog } from "./base/Dialog";

export type ConfirmDialogProps = {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  title: string;
  message: string;
  confirmLabel?: string;
  cancelLabel?: string;
  isLoading?: boolean;
  children?: ReactNode;
  variant?: "danger" | "warning";
};

export const ConfirmDialog = ({
  isOpen,
  onClose,
  onConfirm,
  title,
  message,
  confirmLabel = "Delete",
  cancelLabel = "Cancel",
  isLoading = false,
  children,
  variant = "danger",
}: ConfirmDialogProps) => {
  return (
    <Dialog
      isOpen={isOpen}
      onClose={onClose}
      title={title}
      size="md"
    >
      <View className="flex flex-col p-6">
        <Text className="text-gray-900 dark:text-white mb-4">{message}</Text>
        {children}
      </View>
      <View className="flex items-center justify-end p-6 gap-3 border-t border-gray-200 dark:border-gray-700">
        <Button
          variant="neutral"
          size="auto"
          onClick={onClose}
          disabled={isLoading}
        >
          {cancelLabel}
        </Button>
        <Button
          variant={variant === "danger" ? "danger" : "warning"}
          size="auto"
          onClick={onConfirm}
          disabled={isLoading}
        >
          {isLoading ? (
            <Icon
              name="loader"
              size={14}
              className="animate-spin"
            />
          ) : (
            <Icon
              name="trash"
              size={14}
            />
          )}
          {confirmLabel}
        </Button>
      </View>
    </Dialog>
  );
};
